import { render } from "./NewCropFieldCertification.vue?vue&type=template&id=4b7a1541"
import script from "./NewCropFieldCertification.vue?vue&type=script&lang=js"
export * from "./NewCropFieldCertification.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/crop_field_certification.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fcertifications%2Fbasic_certifications_producers%2FNewCropFieldCertification.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/views/organization/certifications/basic_certifications_producers/new_crop_field_certification.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fcertifications%2Fbasic_certifications_producers%2FNewCropFieldCertification.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__